module.exports = __webpack_public_path__ + "79f0b87304f7b66da2ed2d94df8cefe9.pdf";